<template>
    <div>
        <!-- confirm modal -->
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-confirm custom-modal-confirm"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-small-close" @click="clickSmallClose()">
                <b-icon icon="x"></b-icon>
            </div>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p v-html="title"></p>
                </div>
                <div class="modal-base-body">
                    <p v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <button class="theme-back-btn" @click="clickCancel()">
                        {{ btnCancel }}
                    </button>
                    <button class="ml-2 theme-btn" @click="clickOk()">
                        {{ btnOk }}
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ConfirmModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            btnCancel: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl()
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        clickSmallClose: function() {
            this.hide();
            this.controller.sendCallbackSmallClose({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
@import "./styles/ConfirmModal.scss";
.modal-confirm {
    @extend %modal-base;
}
</style>
